import React, {useContext} from "react";
import "./Works.css";
import Tensorflow from "../../img/Tensorflow.png";
import IBM from "../../img/IBM.png";
import neural from "../../img/neural.png";
import Colab from "../../img/Colab.png";
import GPT from "../../img/GPT.png";
import {themeContext} from "../../Context";
import {motion} from "framer-motion";
import {Link} from 'react-scroll'

const Works = () => {
    // context
    const theme = useContext(themeContext);
    const darkMode = theme?.state.darkMode;

    // transition
    return (
        <div className="works" id="works">
            {/* left side */}
            <div className="w-left">
                <div className="awesome">
                    {/* dark Mode */}
                    <span style={{color: darkMode ? "white" : ""}}>
            I am going to learn
          </span>
                    <span>In progress</span>
                    <span>

                        I have recently embarked on the journey of <br/>
                        learning AI and have successfully completed several
                        <br/>
                        courses on Udemy. My current objective is to attain an IBM badge.            <br/>


          </span>
                    <Link to="contact" smooth={true} spy={true}>
                        <button className="button s-button">Hire Me</button>
                    </Link>
                    <div
                        className="blur s-blur1"
                        style={{background: "#ABF1FF94"}}
                    />
                </div>

                {/* right side */}
            </div>
            <div className="w-right">
                <motion.div
                    initial={{rotate: 45}}
                    whileInView={{rotate: 0}}
                    viewport={{margin: "-40px"}}
                    transition={{duration: 3.5, type: "spring"}}
                    className="w-mainCircle"
                >
                    <div className="w-secCircle">
                        <img src={Tensorflow} alt=""/>
                    </div>
                    <div className="w-secCircle">
                        <img src={IBM} alt=""/>
                    </div>
                    <div className="w-secCircle">
                        <img src={neural} alt=""/>
                    </div>
                    {" "}
                    <div className="w-secCircle">
                        <img src={Colab} alt=""/>
                    </div>
                    <div className="w-secCircle">
                        <img src={GPT} alt=""/>
                    </div>
                </motion.div>
                {/* background Circles */}
                <div className="w-backCircle blueCircle"/>
                <div className="w-backCircle yellowCircle"/>
            </div>
        </div>
    );
};

export default Works;
